import { SBonus } from '../../fonts/SBonus/index.js';
import { SBonusDisplay } from '../../fonts/SBonusDisplay/index.js';
import { Joe182 } from '../../fonts/Joe182/index.js';

var fonts = {
  SBonus: SBonus,
  SBonusDisplay: SBonusDisplay,
  Joe182: Joe182
};

export { fonts };
//# sourceMappingURL=fonts.js.map
